import { createSlice } from '@reduxjs/toolkit'

const initialState: { isRingBuilderReady: boolean } = {
  isRingBuilderReady: false
}

const ringBuilderSlice = createSlice({
  name: 'ringBulider',
  initialState,
  reducers: {
    setRingBuilderReady: (state, action) => {
      state.isRingBuilderReady = action.payload
    }
  }
})

export const { setRingBuilderReady } = ringBuilderSlice.actions

export default ringBuilderSlice.reducer
